import React from "react"
import styled from "styled-components"
import Image from "gatsby-image"
import { Link } from "gatsby"

const ViewList = ({ options, images }) => {
  return (
    <Wrapper>       
      {options.map((item, index) => {
        return (
          <div key={index} className="item">
          {index === 0 && <h2>Who are You</h2> }         
          <h4 className="title">{item.title}</h4>
            <div className="content">  
              <h3>{item.header}</h3>
              <p>{item.text}</p>
              <div className="image">
                <Image
                  fluid={images[index].childImageSharp.fluid}
                  alt={item.title}
                />
              </div>
              <Link to="#" className="btn btn-bordered">
                Learn More
              </Link>
            </div>
          </div>
        )
      })}      
    </Wrapper>
  )
}

const Wrapper = styled.article`
  background: var(--clr-primary-6);
  position: relative;
  margin-top: 150px;
  padding: 20px 0;
  display: inherit;
  @media screen and (min-width: 1025px) {
    display: none;
  }

  .title {
    font-weight: bold;
    font-size: 12px;
    line-height: 190%;    
    text-transform: uppercase;
    margin: 100px 20px 20px;
  }
  .content {
    padding: 20px;
    background: var(--clr-white);
    color: var(--clr-primary-1);
  }

  h2 {
    font-size: 30px;
    margin-bottom: -36px;
    margin-left: 20px;
  }

  .item {
    
    .image {
      width: 85vw;
      margin: 30px auto;
    }
    h3 {
      font-size: 28px;
      line-height: 44px;
    }
    p {
      font-size: 12px;
      line-height: 190%;
    }

    .btn-bordered {
      width: 85vw;
      text-align: center;
      display: block;
      margin: 40px auto 20px;  
      background: var(--clr-white);
      :hover {
        background: var(--clr-primary-1);
      }
    }

    @media screen and (min-width: 360px) {      
        width: 90vw;
        margin: 0 auto;
        .image {
            width: 50vw;
        }
        .btn-bordered {
            width: 50vw;
        }      
    }
    
    @media screen and (min-width: 768px) {
        width: 75vw;
        .image {width: 40vw;}
        .btn-bordered {
            width: 40vw;
        }   
    }
  }
`

export default ViewList
